import React from "react";
import { useHistory } from "react-router-dom";

import { Container, TitleContainer, Title, Icon } from "./styles";

export default function NavigationCard(props) {
  const history = useHistory();
  return (
    <Container
      style={props.bigCard ? {
        width: 450,
        height: 150
      } : null}
      hasChildren={props.children ? true : false}
      hasDisabled={props.disabled}
      align={props.align ? props.align : "center"}
      onClick={() => {
        if(props?.customClick && typeof props?.customClick === 'function') {
          props?.customClick();
          return;
        }
        if(props.path === "/avaliacao") {
          props.setShowModal(true);
        } else {
          history.push(props.path);
        }
      }}
    >
      <TitleContainer hasChildren={props.children ? true : false}>
        {props.customIcon ? (
          props.customIcon
        ) : (
          <Icon
            src={`./assets/images/icons/` + props.icon}
            width={props.iconWidth}
          />
        )}
        <Title>{props.title}</Title>
      </TitleContainer>
      {props.children ? props.children : null}
    </Container>
  );
}
